module.exports = __webpack_public_path__ + "img/top2head@2x.0a96d64b.png";